module.exports = __webpack_public_path__ + "./fonts/Itim_400Regular.ttf";